import { createTheme } from '@mui/material/styles'

export const ArtosTheme = createTheme({
    palette: {
        error: {
            main: '#b00020',
            light: '#bf334c',
            dark: '#7b0016',
            contrastText: '#fff',
        },
        warning: {
            main: '#ffa726',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: '#000',
        },
        info: {
            main: '#29b6f6',
            light: '#4fc3f7',
            dark: '#0288d1',
            contrastText: '#000',
        },
        success: {
            main: '#66bb6a',
            light: '#81c784',
            dark: '#388e3c',
            contrastText: 'rgba(255, 255, 255, 0.12)',
        },
        background: {},
        // divider: '#e5e7eb',
        text: {
            primary: 'rgba(0, 0, 0, 0.87)',
            secondary: 'rgba(0, 0, 0, 0.6)',
            disabled: 'rgba(0, 0, 0, 0.38)',
            hint: '#22194D',
        },
        primary: {
            main: '#1f477d',
            light: '#4793cc',
            dark: '#153157',
            contrastText: '#fff',
        },
    },
    spacing: 8, // Base spacing unit ('8px') 
    shape: {
        borderRadius: 8,
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    typography: {
        fontFamily: ['Plus Jakarta Sans', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'sans-serif'].join(','),
    },
    components: {
        MuiStat: {
            styleOverrides: {
                root: {
                    backgroundColor: '#121212',
                },
                value: {
                    color: '#fff',
                },
                unit: {
                    color: '#888',
                },
            },
        },
    },
})
